import { forwardRef } from 'react'
import classNames from 'classnames'
import s from './table.module.scss'

export const Table = forwardRef(({ className, containerClassName, ...props }, ref) => (
	<div className={classNames(s.wrapper, containerClassName)}>
		<table ref={ref} className={classNames(s.table, className)} {...props} />
	</div>
))

Table.displayName = 'Table'

export const TableHeader = forwardRef(({ className, ...props }, ref) => (
	<thead ref={ref} className={classNames(s.header, className)} {...props} />
))

TableHeader.displayName = 'TableHeader'

export const TableBody = forwardRef(({ className, ...props }, ref) => (
	<tbody ref={ref} className={classNames(s.body, className)} {...props} />
))

TableBody.displayName = 'TableBody'

export const TableFooter = forwardRef(({ className, ...props }, ref) => (
	<tfoot ref={ref} className={classNames(s.footer, className)} {...props} />
))

TableFooter.displayName = 'TableFooter'

export const TableRow = forwardRef(({ className, ...props }, ref) => (
	<tr ref={ref} className={classNames(s.row, className)} {...props} />
))

TableRow.displayName = 'TableRow'

export const TableHead = forwardRef(({ className, contentClassName, children, ...props }, ref) => (
	<th ref={ref} className={classNames(s.head, className)} {...props}>
		<div className={classNames(s.headContent, contentClassName)}>{children}</div>
	</th>
))

TableHead.displayName = 'TableHead'

export const TableCell = forwardRef(({ className, ...props }, ref) => (
	<td ref={ref} className={classNames(s.cell, className)} {...props} />
))

TableCell.displayName = 'TableCell'

export const TableCaption = forwardRef(({ className, ...props }, ref) => (
	<caption ref={ref} className={classNames(s.caption, className)} {...props} />
))

TableCaption.displayName = 'TableCaption'
